import AccountCircleIcon from '@mui/icons-material/AccountCircle';
export default function ProfileIcon() {
    return (
      <AccountCircleIcon />
    )
}